/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
//= require ./markdown_editor

window.FormOfTenders = {
  _gridApi: null,

  _gridOptions: {
    paginationPageSize: 10,
    headerHeight: 38,
    rowHeight: 36,
    domLayout: 'autoHeight',
    rowStyle: { overflow: 'hidden' },
    defaultColDef: {
      sortable: true,
      resizable: true
    },
    onGridSizeChanged(event) {
      return event.api.sizeColumnsToFit();
    },
    getRowHeight(params) {
      if (params.data.question_type === 'text') {
        return 150;
      } else {
        return 40;
      }
    }
  },

  TIME_PERIODS: {
    days: 1,
    hours: 0.0417,
    manHours: 0.0417,
    weeks: 7,
    months: 30,
    years: 365
  },

  _renderCellValue(params) {
    const columnName = params.colDef.field;
    const data = params.data[columnName];

    if (params.data.question_type === 'time') {
      const allGridColumns = this._gridApi.getAllGridColumns();

      let columnFields = _.map(allGridColumns, column => column.colDef.field);
      columnFields = _.without(columnFields, 'description');

      const biddersTimePeriods = _.map(columnFields, columnField => {
        if (!_.isNull(params.data[columnField]['answer'])) {
          const timePeriod = params.data[columnField]['answer'].split(' ');
          const count = timePeriod[0];
          const interval = timePeriod[1];
          return { columnField, days: parseInt(this.TIME_PERIODS[interval] * count) };
        } else {
          return { columnField, days: null };
        }
      });
      const longestTimePeriod = _.max(biddersTimePeriods, bidderTimePeriod => bidderTimePeriod.days);
      const shortestTimePeriod = _.min(biddersTimePeriods, bidderTimePeriod => bidderTimePeriod.days);

      if (longestTimePeriod === shortestTimePeriod) {
        return data.answer;
      } else if (columnName === shortestTimePeriod.columnField) {
        return `<div class='pt-green'>${data.answer}</div>`;
      } else if (columnName === longestTimePeriod.columnField) {
        return `<div class='pt-red'>${data.answer}</div>`;
      }
    } else if (data.url) {
      return "<a class='button micro' href='" + data.url + "'><i class='pti pt-pdf'></i> Download</a>";
    } else if ((params.data.question_type === 'percentage') && data.answer) {
      if ((params.data.description === 'amount_of_performance_security') || (params.data.description === 'advance_payment')) {
        return data.answer + ' of contract value';
      } else if (params.data.description === 'percentage_of_retention') {
        return data.answer + ' of contract value against bank';
      }
    } else {
      return data.answer;
    }
  },

  _fetchCellClass(params) {
    if (params.data.description === 'bidders_total_price') {
      return 'align-right';
    }
  },

  _renderDocumentName(params) {
    return params.data.description;
  },

  refreshTable(tableSelector) {
    const visibleBidders = BiddersUtils.getBidders('visible');
    const allGridColumns = this._gridApi.getAllGridColumns();

    let columnFields = _.map(allGridColumns, column => column.colDef.field);
    columnFields = _.without(columnFields, 'description');

    this._gridApi.setColumnsVisible(columnFields, false);

    const visibleColumnsFields = [];
    const visibleColumns = _.each(visibleBidders, bidderName => {
      const bidderColumn = _.select(allGridColumns, column => bidderName === column.colDef.headerName)[0];
      if (bidderColumn) {
        return visibleColumnsFields.push(bidderColumn.colDef.field);
      }
    });
    return this._gridApi.setColumnsVisible(visibleColumnsFields, true);
  },

  intilizeTable(selector, data) {
    const columns = _.map(data.columns, column => {
      return {
        headerName: column.name,
        field: column.field,
        minWidth: 300,
        cellStyle: { 'white-space': 'normal' },
        cellClass: params => this._fetchCellClass(params),
        cellRenderer: params => this._renderCellValue(params)
      };
    });

    const columnDefs = [
      { headerName: 'Document Name', field: 'description', pinned: 'left', minWidth: 300, cellRenderer: this._renderDocumentName }
    ].concat(columns);

    this._gridOptions.columnDefs = columnDefs;
    this._gridOptions.rowData = data.rows;

    const eGridDiv = document.getElementById(selector);
    this._gridApi = agGrid.createGrid(eGridDiv, this._gridOptions);
    this._gridOptions.api = this._gridApi;
    return resizeAgGridTable(`#${selector}`, this._gridOptions);
  },

  initializeEditors() {
    return $('#form_of_tenders_form textarea').map(function () {
      return MarkdownEditor.initialize(this);
    });
  },

  _resetBidderQuestionsForm(data, event) {
    const questionsTableBody = $('#fot-questions-table tbody');
    questionsTableBody.empty();

    if (data.form_of_tender.template_id) {
      const selected_template = _.find(data.bidder_question_templates, template => template.id === data.form_of_tender.template_id);

      $('#selected-template-name').text(selected_template.discarded_at ? I18n.t("v4.form_of_tenders.template.removed", { name: selected_template.name }) : selected_template.name);
      $('#bidder_question_templates').val(data.form_of_tender.template_id);

      this._renderTable(data.form_of_tender.questions, data);
      return $('#fot-questions-table').show();
    } else {
      $('#bidder_question_templates').val(null);
      return $('#fot-questions-table').hide();
    }
  },

  _selectTemplateQuestions(data, event) {
    const selectedId = parseInt($(event.currentTarget).val());

    const questionsTableBody = $('#fot-questions-table tbody');
    questionsTableBody.empty();

    $('#fot-questions-table').hide();
    if (isNaN(selectedId)) { return; }

    const template = _.find(data.bidder_question_templates, template => template.id === selectedId);

    this._renderTable(template.questions, data);
    return $('#fot-questions-table').show();
  },

  _renderTable(questions, data) {
    _.map(questions, function (question) {
      const bidderQuestion = _.find(data.bidder_questions, bq => bq.id === question.bidder_question_id);
      question.title = bidderQuestion.title;
      question.type = bidderQuestion.type;
      question.priority = bidderQuestion.priority;
      return question.currency = data.currency;
    });
    const sortedQuestions = _.sortBy(questions, 'priority');
    const questionsTableBody = $('#fot-questions-table tbody');

    _.map(sortedQuestions, question => {
      row = this._renderRow(question)
      questionsTableBody.append(row);
      return $(`input[name='form_of_tender_bidder_questions[${question.bidder_question_id}][required]']`).prop('checked', question.required);
    });

    if (this.fotLocked) {
      return $("#fot-questions-table table input[type!='hidden']").map(function () {
        return $(this).attr('disabled', true);
      });
    }
  },

  _renderRow(question) {
    const i18n_title = params.data.description;
    const i18n_category = question.category;
    row = `\
<tr class='fields'>
  <td>
    ${i18n_title}
    <input type='hidden' name='form_of_tender_bidder_questions[${question.bidder_question_id}][included]' value='${!!question}'>
  </td>
  <td>${this._defaultValueRenderer(question)}</td>
  <td>
    ${i18n_category}
    <input type='hidden' name='form_of_tender_bidder_questions[${question.bidder_question_id}][category]' value='${question.category}'>
  </td>
  <td>
    <label class='custom-checkbox'>
      <input type='checkbox' name='form_of_tender_bidder_questions[${question.bidder_question_id}][required]' value='1' checked='${question.required}' id='form_of_tender_bidder_questions_${question.bidder_question_id}_required' class='check-box required-box' data-required='true'>
      <span class="checkbox"></span>
    </label>
  </td>
</tr>\
`;
    return row;
  },

  _defaultValueRenderer(question) {
    switch (question.type) {
      case 'percentage':
        return this._percentageType(question);
      case 'numerical':
        return this._numericalType(question);
      case 'time':
        return this._timeType(question);
      default:
        return '';
    }
  },

  _percentageType(question) {
    const inputType = this.fotLocked ? 'hidden' : 'number';
    const defaultValue = this.fotLocked ? question.default_value : '';

    const suffix = (() => {
      switch (question.title) {
        case 'amount_of_performance_security': case 'advance_payment': return ' of contract value';
        case 'percentage_of_retention': return ' of contract value against bank';
        default: return '';
      }
    })();

    inputText = `\
<input type=${inputType} name='form_of_tender_bidder_questions[${question.bidder_question_id}][default_value]' value='${question.default_value}' class='inline nano'>
${defaultValue}<span>${suffix}</span>\
`;
    return inputText
  },

  _numericalType(question) {
    const inputType = this.fotLocked ? 'hidden' : 'number';
    const defaultValue = this.fotLocked ? question.default_value : '';
    inputText = `\
<input type=${inputType} name='form_of_tender_bidder_questions[${question.bidder_question_id}][default_value]' value='${question.default_value}' class='inline nano'>
<span>${question.currency} ${defaultValue} ${I18n.t('v4.form_of_tenders.form.perday')}</span>\
`;
    return inputText;
  },

  _timeType(question) {
    const value = question.default_value ? question.default_value.trim().split(' ') : [];
    if (this.fotLocked) {
      inputText = `\
${question.default_value}
<input type='hidden' name='form_of_tender_bidder_questions[${question.bidder_question_id}][default_value][time_interval_1]' value='${value[0] || ''}'>
<input type='hidden' name='form_of_tender_bidder_questions[${question.bidder_question_id}][default_value][time_interval_2]' value='${value[1] || ''}'>\
`;
    } else {
      const timeOptions = [['Man-Hours', 'manHours'], ['Hours', 'hours'], ['Days', 'days'], ['Weeks', 'weeks'], ['Months', 'months'], ['Years', 'years']];
      let options = "<option value='' label=' '></option>";
      for (let i = 0; i < timeOptions.length; i++) {
        const option = timeOptions[i];
        const selected = option[1] === (value[1] || '') ? 'selected' : '';
        options = options.concat(`<option value=${option[1]} ${selected}>${option[0]}</option>`);
      }
      inputText = `\
<input type='number' name='form_of_tender_bidder_questions[${question.bidder_question_id}][default_value][time_interval_1]' value='${value[0] || ''}' class='inline nano short'>
<select name="form_of_tender_bidder_questions[${question.bidder_question_id}][default_value][time_interval_2]" class="inline nano short" aria-invalid="false">${options}</select>\
`;
    }
    return inputText
  },

  initializeFotEditor(data) {
    this.fotLocked = data.form_of_tender.locked;
    this._resetBidderQuestionsForm(data, null);
    $(document).on('change', '#bidder_question_templates', _.bind(this._selectTemplateQuestions, this, data));
    return $(document).on('click', '#form_of_tenders_reset_button', _.bind(this._resetBidderQuestionsForm, this, data));
  }
};
